import { render, staticRenderFns } from "./InterconsultaView.vue?vue&type=template&id=7f81fe24"
import script from "./InterconsultaView.vue?vue&type=script&lang=js"
export * from "./InterconsultaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports